import Table from 'react-bootstrap/Table'

function ViewCuenta({selectedCuenta}) {
    return (
        <Table striped bordered hover>
            <tbody>
                <tr>
                    <th>Código</th>
                    <td>{selectedCuenta.codigo}</td>
                </tr>
                <tr>
                    <th>Descripción</th>
                    <td>{selectedCuenta.descripcion}</td>
                </tr>
                <tr>
                    <th>Activo</th>
                    <td>{selectedCuenta.activo ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <th>Dirección Administrativa</th>
                    <td>{selectedCuenta.direccion_administrativa}</td>
                </tr>
            </tbody>
        </Table>
    )
}

export default ViewCuenta